import Axios from 'axios';

const axiosBaseURL = Axios.create({
    //  baseURL:'https://course.boltiot.com/api/'
     baseURL: window.location.origin + '/api/'
});
export default axiosBaseURL